define([
	"csi/action/AggregateBase",
	"csi/def/ActionFactory",
	"csi/reflection",
	"csi/util",
	"csi/xml"
], function(AggregateBase, ActionFactory, reflection, util, xml) {

	return ActionFactory.declare("AggregateFrom", AggregateBase, {
		// String: default tag for action
		m_tag: "AggregateFrom",

		constructor: function(def) {
			this.m_typeNodeHint = util.getProperty(def, "Type", "");	// optional hint to name action
			this.setBaseRights(null, xml.RIGHT_WRITE);
		},

		checkParentAccess: function(nodeParent, idAttrParent) {
			// summary: make sure the attribute is enabled and editable unless reverse aggregation
			return this._checkAccess(nodeParent, this.m_rightParent, this.m_rightParentBase);
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: if the type of Node is known, make sure it's not abstract
			var rc = reflection.getClass(this.aggregateClass);
			if (rc?.abstractOrDisabled) {
				return false;
			}

			return this.inherited(arguments);
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: fill aggregate id if not specified explicitly
			this.aggregateId = this.aggregateId || this.m_relationship.m_id;
			this.inherited(arguments);
		},

		_getNameParams: function(/*csi.LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			if (this.m_typeNodeHint) {
				return [lr.getTypeName(this.m_typeNodeHint)];
			}

			if (this.aggregateClass && this.m_rcTarget && !this.bReverse) {
				var rc = this.m_rcTarget.getChildClass(this.aggregateId);

				if (rc && this.aggregateClassIds) {
					rc = rc.getChildClass(this.aggregateClassIds[0]);
				}

				return rc ? [lr.getTypeName(rc)] : null;
			}

			return this.inherited(arguments);
		},

		_getNameTag: function(/*csi.LocaleResolver*/lr) {
			// summary: if no AggregateClass, then use Aggregate tag
			return (this.aggregateClass && !this.bReverse) ? "AggregateFromClass" : this.m_tag;
		}
	});
});